import React, { useState, useEffect } from 'react';
import { HashLink } from 'react-router-hash-link';
import './NavBar.css';
import logo from '../images/Logo_Tekins_300x100-01.png';

const navLinks = [
  { label: 'Soluciones en la nube', to: '/#soluciones' },
  { label: 'Office 365', to: '/#office365' },
  { label: 'Seguridad', to: '/Seguridad' },
  { label: 'Factoring', to: '/Factoring' }
];

function NavBar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth > 960);

  useEffect(() => {
    const handleResize = () => setIsDesktop(window.innerWidth > 960);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isDesktop && menuOpen) {
      setMenuOpen(false);
    }
  }, [isDesktop, menuOpen]);

  const toggleMenu = () => setMenuOpen((prev) => !prev);
  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className='navbar'>
      <div className='navbar-container'>
        <HashLink smooth to='/' className='navbar-logo' onClick={closeMenu}>
          <img src={logo} alt='Tekins' />
        </HashLink>

        <button className='menu-icon' onClick={toggleMenu} aria-label='Abrir menú'>
          <i className={menuOpen ? 'fas fa-times' : 'fas fa-bars'} />
        </button>

        <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
          {navLinks.map((link) => (
            <li key={link.label} className='nav-item'>
              <HashLink smooth to={link.to} className='nav-links' onClick={closeMenu}>
                {link.label}
              </HashLink>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
}

export default NavBar;
